import React from "react";
import { MaskedLines } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, italic, description, testId }) {
  return (
    <section
      className="relative pt-40 pb-24 lg:pt-52 lg:pb-32 px-6 lg:px-10 overflow-hidden border-b border-[color:var(--border)]"
      data-testid={testId || "page-hero"}
    >
      <div className="ambient-glow-navy" style={{ top: "-10%", right: "-20%", opacity: 0.55 }} />
      <div className="ambient-glow-blue" style={{ bottom: "-40%", left: "-20%", opacity: 0.35 }} />

      <div className="mx-auto max-w-[1400px] relative">
        <div className="flex items-center gap-4 mb-8">
          <div className="h-[1px] w-16 bg-[color:var(--blue)]" />
          <div className="text-[11px] uppercase tracking-[0.4em] text-[color:var(--blue)]">
            {eyebrow}
          </div>
        </div>

        <MaskedLines
          lines={[
            title,
            italic
              ? `<span class="font-editorial font-normal italic text-[color:var(--blue)]">${italic}</span>`
              : "",
          ].filter(Boolean)}
          className="font-display font-semibold text-white text-[clamp(3rem,9vw,9rem)] leading-[0.9]"
          stagger={0.13}
          delay={0.3}
        />

        {description && (
          <div className="mt-12 grid grid-cols-12">
            <p className="col-span-12 lg:col-span-6 lg:col-start-7 text-[16px] lg:text-[18px] leading-[1.75] text-[color:var(--muted)] font-body max-w-xl">
              {description}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
